import { DeviationsLoader } from "@src/to-be-removed/api/deviations/deviations.loader";
import { Tag } from "data-hooks/company/tags/tags.type";
import { t } from "i18next";
import { DataTableData, DataTableHeader } from "../../../../../components/deprecated/DataTable/DataTable";
import { Utilities } from "../../../../../utils/utilities";
import { DeviationData } from "../../../Deviation/DeviationData";
import { DeviationUpdateData } from "../../../Deviation/DeviationUpdateData";
import {
  DataObjectTagField,
  DeviationDataInvoicedToField,
  DeviationDataPriorityField,
  DeviationDataStatusField,
  DeviationDataVisibilityField,
  FirebaseDataDeviationField,
} from "../../DataObjectField/CustomFields/DeviationDataFields";
import { FirebaseDataContractorField } from "../../DataObjectField/CustomFields/FirebaseDataContractorField";
import { FirebaseDataApiClientField } from "../../DataObjectField/CustomFields/FirebaseDataFields";
import { FirebaseDataFirebaseFileField } from "../../DataObjectField/CustomFields/FirebaseDataFirebaseFileField";
import { FirebaseDataUnitField } from "../../DataObjectField/CustomFields/FirebaseDataUnitField";
import { FirebaseDataUserField } from "../../DataObjectField/CustomFields/FirebaseDataUserField";
import { PropertyDataFloorsField } from "../../DataObjectField/CustomFields/PropertyFields";
import { FirebaseDataBooleanField } from "../../DataObjectField/Generic/FirebaseDataBooleanField";
import { FirebaseDataDateField } from "../../DataObjectField/Generic/FirebaseDataDateField";
import { FirebaseDataStringField } from "../../DataObjectField/Generic/FirebaseDataStringField";
import { DataObjectHelper } from "../../DataObjects/DataObjectHelper";
import { DataObjectHelpers } from "../../DataObjects/DataObjectHelpers";
import { LocalData } from "../../LocalData";

export class DeviationUpdateDataHelper extends DataObjectHelper<DeviationUpdateData> {
  id = () => "deviationUpdate";

  displayName = () => t("main.deviationUpdated");

  deviation = new FirebaseDataDeviationField<DeviationUpdateData>("deviation", t("main.deviation"), (data) =>
    data.parent instanceof DeviationData ? data.parent : undefined
  );
  units = new FirebaseDataUnitField<DeviationUpdateData>("units", t("main.tenants"), (data) => data.units, "meeting_room", true);
  user = new FirebaseDataUserField<DeviationUpdateData>("user", t("main.createdBy"), (data) => data.user, "person_add");
  status = new DeviationDataStatusField<DeviationUpdateData>("status", t("main.status"), (data) => data.status, "done");
  priority = new DeviationDataPriorityField<DeviationUpdateData>("priority", t("main.priority"), (data) => data.priority, "priority_high");
  date = new FirebaseDataDateField<DeviationUpdateData>("date", t("main.date"), (data) => data.date, "schedule");
  comment = new FirebaseDataStringField<DeviationUpdateData>("comment", t("main.comment"), (data) => data.comment, "edit");
  archived = new FirebaseDataBooleanField<DeviationUpdateData>("archived", t("main.isArchived"), (data) => data.archived, "archive");
  tags = new DataObjectTagField<DeviationUpdateData>(
    "tags",
    t("main.tags"),
    (data) => (data.tags?.map((tag) => LocalData.getTagWithId(tag))?.filter(Boolean) ?? []) as Tag[],
    "category",
    true
  );
  floors = new PropertyDataFloorsField<DeviationUpdateData>("floors", t("main.floors"), (data) => data.floors, "trending_up", true);
  placeDescription = new FirebaseDataStringField<DeviationUpdateData>(
    "placeDescription",
    t("main.placeDescription"),
    (data) => data.placeDescription,
    "place"
  );
  startDate = new FirebaseDataDateField<DeviationUpdateData>("startDate", t("main.startDate"), (data) => data.startDate, "play_arrow");
  deadline = new FirebaseDataDateField<DeviationUpdateData>("deadline", t("main.deadline"), (data) => data.endDate, "last_page");
  newTitle = new FirebaseDataStringField<DeviationUpdateData>("newTitle", t("main.updatedTitleTo"), (data) => data.newTitle, "title");
  oldTitle = new FirebaseDataStringField<DeviationUpdateData>("oldTitle", t("main.oldTitle"), (data) => data.oldTitle, "title");
  newDescription = new FirebaseDataStringField<DeviationUpdateData>("newDescription", t("main.description"), (data) => data.newDescription, "edit");
  oldDescription = new FirebaseDataStringField<DeviationUpdateData>(
    "oldDescription",
    t("main.oldDescription"),
    (data) => data.oldDescription,
    "edit"
  );
  contractorGroups = new FirebaseDataContractorField<DeviationUpdateData>(
    "contractorGroups",
    t("main.contractorGroups"),
    (data) => data.contractorGroups,
    "build_circle",
    true
  );
  removedContractorGroups = new FirebaseDataContractorField<DeviationUpdateData>(
    "removedContractorGroups",
    t("main.removedContractors"),
    (data) => data.removedContractorGroups,
    "build_circle",
    true
  );
  addedResponsibles = new FirebaseDataUserField<DeviationUpdateData>(
    "addedResponsibles",
    t("main.addedResponsibles"),
    (data) => data.addedResponsibles,
    "supervisor_account",
    true
  );
  removedResponsibles = new FirebaseDataUserField<DeviationUpdateData>(
    "removedResponsibles",
    t("main.removedResponsibles"),
    (data) => data.removedResponsibles,
    "supervisor_account",
    true
  );
  addedExecutors = new FirebaseDataUserField<DeviationUpdateData>(
    "addedExecutors",
    t("main.addedExecutors"),
    (data) => data.addedExecutors,
    "people_alt",
    true
  );
  removedExecutors = new FirebaseDataUserField<DeviationUpdateData>(
    "removedExecutors",
    t("main.removedExecutors"),
    (data) => data.removedExecutors,
    "people_alt",
    true
  );

  senderName = new FirebaseDataStringField<DeviationUpdateData>("senderName", t("main.senderName"), (data) => data.senderName, "title");
  senderRole = new FirebaseDataStringField<DeviationUpdateData>("senderRole", t("main.senderRole"), (data) => data.senderRole, "title");
  senderEmail = new FirebaseDataStringField<DeviationUpdateData>("senderEmail", t("main.senderEmail"), (data) => data.senderEmail, "title");
  senderPhone = new FirebaseDataStringField<DeviationUpdateData>("senderPhone", t("main.senderPhone"), (data) => data.senderPhone, "title");

  // Relatives
  files = new FirebaseDataFirebaseFileField<DeviationUpdateData>("files", t("main.files"), (data) => data.files, "description", true);
  images = new FirebaseDataFirebaseFileField<DeviationUpdateData>("images", t("main.images"), (data) => data.images, "photo_camera", true);
  updatedVisibility = new DeviationDataVisibilityField<DeviationUpdateData>(
    "updatedVisibility",
    t("main.updatedVisibilityTo"),
    (data) => data.updatedVisibility,
    "visibility_off"
  );
  invoicedTo = new DeviationDataInvoicedToField<DeviationUpdateData>("invoicedTo", t("main.invoicedTo"), (data) => data.invoicedTo, "attach_money");
  seenBy = new FirebaseDataUserField<DeviationUpdateData>(
    "seenBy",
    t("main.seenBy"),
    (data) => data.seenBy.map((seenBy) => seenBy.user),
    "visibility",
    true
  );
  createdByApiClient = new FirebaseDataApiClientField<DeviationUpdateData>(
    "createdBy.apiClient",
    t("main.createdByApiClient"),
    (data) => data.createdBy?.apiClient
  );

  allFields() {
    return [
      this.deviation,
      this.units,
      this.user,
      this.status,
      this.priority,
      this.date,
      this.comment,
      this.archived,
      this.tags,
      this.floors,
      this.placeDescription,
      this.startDate,
      this.deadline,
      this.newTitle,
      this.oldTitle,
      this.newDescription,
      this.oldDescription,
      this.contractorGroups,
      this.removedContractorGroups,
      this.addedResponsibles,
      this.removedResponsibles,
      this.addedExecutors,
      this.removedExecutors,
      this.senderName,
      this.senderRole,
      this.senderEmail,
      this.senderPhone,
      this.files,
      this.images,
      this.updatedVisibility,
      this.invoicedTo,
      this.seenBy,
      this.createdByApiClient,
    ];
  }

  override getAllDatas(): DeviationUpdateData[] {
    const updates: DeviationUpdateData[] = [];
    for (const deviation of DeviationsLoader.getInstance().getAllDeviationDatas()) {
      for (const update of deviation.updates.documents) {
        updates.push(update);
      }
    }
    return updates;
  }

  override async loadAll(): Promise<any> {
    const allDeviationUpdates: DeviationUpdateData[] = [];
    const allPromises: Promise<any>[] = [];

    let deviations: DeviationData[] = [];
    deviations = DataObjectHelpers.deviation.areAllLoaded() ? DataObjectHelpers.deviation.getAllDatas() : await DataObjectHelpers.deviation.loadAll();

    for (const deviation of deviations) {
      const promise = new Promise<DeviationUpdateData[]>((resolve) => {
        deviation.updates.load((updates) => {
          for (const update of updates) {
            if (!allDeviationUpdates.includes(update)) {
              allDeviationUpdates.push(update);
            }
          }
          resolve(updates);
        });
      });
      allPromises.push(promise);
    }
    return Promise.all(allPromises);
  }

  getAllDataTableDatas(documents: DeviationUpdateData[]): DataTableData[] {
    return documents.map((update) => {
      return {
        key: update.id,
        cells: {
          reportedBy: update.user?.name ?? update.senderName,
          reportedDate: update.date ? Utilities.formatDate(update.date, "dd/mm/yyyy hh:MM") : "",
          text: update.getUpdateContent().join(". "),
          images: "",
        },
      };
    });
  }

  getAllDataTableHeaders(): DataTableHeader[] {
    return [
      {
        key: "reportedBy",
        title: t("main.reportedBy"),
      },
      {
        key: "reportedDate",
        title: t("main.reportDate"),
      },
      {
        key: "text",
        title: t("main.activity"),
      },
    ];
  }
}
